var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 28.8671C15.5867 28.8671 15.1867 28.8138 14.8534 28.6938C9.76008 26.9471 1.66675 20.7471 1.66675 11.5871C1.66675 6.92045 5.44008 3.13379 10.0801 3.13379C12.3334 3.13379 14.4401 4.01379 16.0001 5.58712C17.5601 4.01379 19.6667 3.13379 21.9201 3.13379C26.5601 3.13379 30.3334 6.93379 30.3334 11.5871C30.3334 20.7605 22.2401 26.9471 17.1467 28.6938C16.8134 28.8138 16.4134 28.8671 16.0001 28.8671ZM10.0801 5.13379C6.54675 5.13379 3.66675 8.02712 3.66675 11.5871C3.66675 20.6938 12.4267 25.7605 15.5067 26.8138C15.7467 26.8938 16.2667 26.8938 16.5067 26.8138C19.5734 25.7605 28.3467 20.7071 28.3467 11.5871C28.3467 8.02712 25.4667 5.13379 21.9334 5.13379C19.9067 5.13379 18.0267 6.08046 16.8134 7.72046C16.4401 8.22712 15.5867 8.22712 15.2134 7.72046C13.9734 6.06712 12.1067 5.13379 10.0801 5.13379Z",
    fill: "url(#paint0_linear_491_2933)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_491_2933",
    x1: 1.66675,
    y1: 3.13379,
    x2: 32.2417,
    y2: 5.64638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCD9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EF82"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.c6dc3e3f6189772e772770213e98bebb.svg";
export { ForwardRef as ReactComponent };